import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ictnotes',
  templateUrl: './ictnotes.component.html',
  styleUrls: ['./ictnotes.component.css']
})
export class IctnotesComponent implements OnInit {
  data = [
    { Theory: 'chapter 1' , PDF_Files: 'Download', link: '../../assets/pdf/csch1.pdf',Practical: 'chapter 9', PDF: 'Download', link1: '../../assets/pdf/csch9.pdf'},
    { Theory: 'chapter 2' , PDF_Files: 'Download', link: '../../assets/pdf/csch2.pdf',Practical: 'chapter 10', PDF: 'Download', link1: '../../assets/pdf/csch9.pdf'},
    { Theory: 'chapter 3' , PDF_Files: 'Download', link: '../../assets/pdf/csch3.pdf',Practical: 'chapter 11', PDF: 'Download', link1: '../../assets/pdf/csch10.pdf'},
    { Theory: 'chapter 4' , PDF_Files: 'Download', link: '../../assets/pdf/csch4.pdf',Practical: 'chapter 12', PDF: 'Download', link1: '../../assets/pdf/csch11.pdf'},
    { Theory: 'chapter 5' , PDF_Files: 'Download', link: '../../assets/pdf/csch5.pdf',Practical: 'chapter 13', PDF: 'Download', link1: '../../assets/pdf/csch12.pdf'},
    { Theory: 'chapter 6' , PDF_Files: 'Download', link: '../../assets/pdf/csch6.pdf',Practical: 'chapter 14', PDF: 'Download', link1: '../../assets/pdf/csch13.pdf'}
  ];
  headers =  [
    {key: 'Theory' , label : 'Theory'},
    {key: 'PDF_Files' , label : 'PDF_Files'},
    {key: 'Practical' , label : 'Practical'},
    {key: 'PDF' , label : 'PDF'},
    
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
